import * as React from 'react'
import { SVGProps } from 'react'

const SvgPauseIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M11.8754 7.99536C12.612 7.99536 13.2091 8.59249 13.2091 9.32908V22.6663C13.2091 23.4029 12.612 24 11.8754 24C11.1388 24 10.5416 23.4029 10.5416 22.6663V9.32908C10.5416 8.59249 11.1388 7.99536 11.8754 7.99536Z'
      fill={props.color ?? '#CC3E76'}
    />
    <path
      d='M11.8754 7.99536C12.612 7.99536 13.2091 8.59249 13.2091 9.32908V22.6663C13.2091 23.4029 12.612 24 11.8754 24C11.1388 24 10.5416 23.4029 10.5416 22.6663V9.32908C10.5416 8.59249 11.1388 7.99536 11.8754 7.99536Z'
      fill='url(#paint0_linear_56_14)'
      fill-opacity='0.25'
    />
    <path
      d='M20.8646 7.99536C21.6012 7.99536 22.1984 8.59249 22.1984 9.32908V22.6663C22.1984 23.4029 21.6012 24 20.8646 24C20.128 24 19.5309 23.4029 19.5309 22.6663V9.32908C19.5309 8.59249 20.128 7.99536 20.8646 7.99536Z'
      fill={props.color ?? '#CC3E76'}
    />
    <path
      d='M20.8646 7.99536C21.6012 7.99536 22.1984 8.59249 22.1984 9.32908V22.6663C22.1984 23.4029 21.6012 24 20.8646 24C20.128 24 19.5309 23.4029 19.5309 22.6663V9.32908C19.5309 8.59249 20.128 7.99536 20.8646 7.99536Z'
      fill='url(#paint1_linear_56_14)'
      fill-opacity='0.25'
    />
    <defs>
      <linearGradient
        id='paint0_linear_56_14'
        x1='16.37'
        y1='7.99536'
        x2='16.37'
        y2='24'
        gradientUnits='userSpaceOnUse'
      >
        <stop stop-color='white' />
        <stop offset='1' stop-color='white' stop-opacity='0' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_56_14'
        x1='16.37'
        y1='7.99536'
        x2='16.37'
        y2='24'
        gradientUnits='userSpaceOnUse'
      >
        <stop stop-color='white' />
        <stop offset='1' stop-color='white' stop-opacity='0' />
      </linearGradient>
    </defs>
  </svg>
)

export default SvgPauseIcon
